import './App.css';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import Home from './Components/Home/Home/Home';
import Login from './Components/Login/Login/Login';
import Order from './Components/Order/Order/Order';
import { createContext, useState } from 'react';
import OrderList from './Components/Order/OrderList/OrderList';
import Review from './Components/Order/Review/Review';
import ServiceOrder from './Components/Home/Services/ServiceOrder/ServiceOrder';
import PrivateRoute from './Components/PrivateRoute/PrivateRoute';
import AddService from './Components/AddService/AddService/AddService';
import AddAdmin from './Components/AddAdmin/AddAdmin';
import ManageServices from './Components/ManageServices/ManageServices';
import OrderListAdmin from './Components/OrderAdmin/OrderListAdmin/OrderListAdmin';

export const UserContext = createContext();
export const AdminContext = createContext();
export const ServiceOrderContext = createContext()

function App() {
  const [loggedInUser, setLoggedInUser] = useState({})
  const [isAdmin, setIsAdmin] = useState(false)
  const [serviceOrder, setServiceOrder] = useState({})
  return (
    <UserContext.Provider value={[loggedInUser, setLoggedInUser]}>
    <AdminContext.Provider value={[isAdmin, setIsAdmin]}>
      <ServiceOrderContext.Provider value={[serviceOrder, setServiceOrder]}>
      <Router>
        <Switch>
          <Route exact path="/">
              <Home />
          </Route>
          <Route path="/login">
              <Login />
          </Route>
          <PrivateRoute path="/order">
              <Order />
          </PrivateRoute>
          <PrivateRoute path="/orderlist">
            <OrderList />
          </PrivateRoute>
          <PrivateRoute path="/orderlistadmin">
            <OrderListAdmin />
          </PrivateRoute>
          <PrivateRoute path="/review">
            <Review />
          </PrivateRoute>
          <PrivateRoute path="/service/:id">
            <ServiceOrder />
          </PrivateRoute>
          <PrivateRoute path="/addservice">
            <AddService />
          </PrivateRoute>
          <PrivateRoute path="/addadmin">
            <AddAdmin />
          </PrivateRoute>
          <PrivateRoute path="/manageservices">
            <ManageServices />
          </PrivateRoute>
        </Switch>
      </Router>
    </ServiceOrderContext.Provider>
    </AdminContext.Provider>
    </UserContext.Provider>
  );
}

export default App;
